import CourtType from "../enums/court-type";
import TiebreakType from "../enums/tiebreak-type";
import GameType from "../enums/game-type";
import ScoringMode from "../enums/scoring-mode";

const DefaultTennisConfig = Object.freeze({
    singles: {
        numberOfMatches: 6,
        gameType: GameType.BestOf3.code,
        tieBreakType: TiebreakType.SevenPoints.code,
        courtType: CourtType.Grass.code,
        gamesPerSet: 6,
        scoringMode: ScoringMode.OnePointPerMatch.code
    },
    doubles: {
        numberOfMatches: 3,
        gameType: GameType.SingleSet.code,
        tieBreakType: TiebreakType.SevenPoints.code,
        courtType: CourtType.Clay.code,
        gamesPerSet: 6,
        scoringMode: ScoringMode.BestOfSeries.code
    }
});

export { DefaultTennisConfig };
